module.exports = __webpack_public_path__ + "static/media/Goodnest_ios_1_preview.f0d31b76.jpg";